import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Img from "gatsby-image"
import { AccentBoxWhite, AccentFullBorder } from "../AccentBoxes"
import ButtonLink from "../ButtonLink"

const Welcome = ({ subTitle, text }) => {
  const data = useStaticQuery(graphql`
    query {
      greetingsImage: file(
        relativePath: { eq: "William- Nature Picture.JPG" }
      ) {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  const greetingsImage = data.greetingsImage.childImageSharp.fluid

  return (
    <div className="grid  gap-x-10 items-end  -mt-20  shadow-md rounded border border-gray-100">
      <div className="grid col-gap-5 xl:grid-cols-2 justify-center  bg-white  bg-opacity-75 p-5">
        <div className=" xl:pl-6 xl:pt-6 mb-6">
          <h1 className=" text-blue-dark text-center text-5xl ">Greetings</h1>
          <p className="text-blue-light text-2xl">{text}</p>
          <div className="flex justify-end">
            <ButtonLink handle="about" text="About Us" className="text-2xl  " />
          </div>
        </div>
        <div className="relative">
          <Img
            fluid={greetingsImage}
            className="z-10"
            style={{ height: 500 }}
          />
        </div>
      </div>
    </div>
    // <article className="index__row1">
    //   <article className="index__welcome-section">
    //     <div className="index__welcome-section-pseudoBG">
    //       <div className="index__welcome-section-title-container">
    //         <h1 className="index__welcome-section-title">
    //           Welcome to Wawakapewin First Nation
    //         </h1>
    //       </div>
    //       <p className="index__welcome-section-content">
    //         Lorem ipsum, or lipsum as it is sometimes known, is dummy text used
    //         in print industries
    //       </p>
    //     </div>
    //   </article>
    //   <article className="index__greetings-section">
    //     <div className="index__greetings-section-left-content-container">
    //       <h3 className="index__greetings-section-title">Greetings</h3>
    //       <p className="index__greetings-section-content">
    //         Wawakapewin is an active community with a number of exciting
    //         initatives. From our Land Use Planning initiatives with the province
    //         of Ontario to our Food Security initiatives. The community is tiny
    //         and very isolated so our staff...
    //       </p>
    //       <a
    //         href="#"
    //         className="index__greetings-section-button settings__mainButton"
    //       >
    //         Continue
    //       </a>
    //     </div>
    //     <BackgroundImage
    //       Tag="div"
    //       fluid={queryData.plantBG.childImageSharp.fluid}
    //       className="index__greetings-section-image-container"
    //     >
    //       <span className="index__greetings-section-image-container-arrow">
    //         {props.textIcon}
    //       </span>
    //     </BackgroundImage>
    //     <span className="index__greetings-section-accent-box1"></span>
    //     <span className="index__greetings-section-accent-box2"></span>
    //   </article>
    // </article>
  )
}

export default Welcome
